import { render, staticRenderFns } from "./OffSet.vue?vue&type=template&id=b5fe305a&scoped=true"
import script from "./OffSet.vue?vue&type=script&lang=js"
export * from "./OffSet.vue?vue&type=script&lang=js"
import style0 from "./OffSet.vue?vue&type=style&index=0&id=b5fe305a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fe305a",
  null
  
)

export default component.exports